import React, { createContext, useContext, useState, useEffect } from 'react';
import { ValidateTokens, Logout } from '../components/axios';

const AuthContext = createContext();

export function AuthProvider({ children }) {
	const [isAuthenticated, setIsAuthenticated] = useState(undefined);

	useEffect(() => {
		ValidateTokens().then(setIsAuthenticated);
	}, []);

	const logout = () => {
		Logout();
		setIsAuthenticated(false);
	};

	return (
		<AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated, logout }}>
			{children}
		</AuthContext.Provider>
	);
}

export function useAuth() {
	return useContext(AuthContext);
}